import "./slider.css";
import SlickSlider from "react-slick";
import { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import bidingimg from "../../myimgs/Rectangle30.png";
import Swal from "sweetalert2";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { formatNumberCA } from "../../utils/numberFormat";
import arowr from "../../myimgs/whitedownld.png";
import { Link } from "react-router-dom";
import Residin from "../../myimgs/Union (2).png";
import Sold from "../../myimgs/sold.png"
const PropertySlider = () => {
  const [propertyCards, setPropertyCards] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const userId = localStorage.getItem("userId");
  const [isResidential, setIsResidential] = useState(true);

  const toggleFavorite = async (propertyId, listingId) => {
    const userId = localStorage.getItem("userId");

    if (!userId) {
      Swal.fire({
        title: "Login Required",
        text: "Please login first to add properties to your favorites.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    // optimistic UI
    setFavorites((prev) =>
      prev.includes(propertyId)
        ? prev.filter((favId) => favId !== propertyId)
        : [...prev, propertyId],
    );

    try {
      const baseURL = process.env.REACT_APP_API_BASE_URL;
      let url = "";

      if (propertyId && propertyId !== "null" && propertyId !== "") {
        url = `${baseURL}/favorites/mark?userId=${userId}&propertyId=${propertyId}`;
      } else if (listingId) {
        url = `${baseURL}/favorites/mark?userId=${userId}&listingId=${listingId}`;
      } else {
        console.error("Both propertyId and listingId are missing");
        return;
      }

      const response = await axios.post(url);

      if (response.status === 200) {
        console.log("Favorite updated successfully:", response.data);
      }
    } catch (error) {
      console.error("Error updating favorite:", error);
    }
  };

  const [slides, setSlides] = useState(3);

  useEffect(() => {
    const updateSlides = () => {
      const width = window.innerWidth;

      if (width <= 768) {
        setSlides(1);
      } else if (width <= 992) {
        setSlides(3);
      } else {
        setSlides(4);
      }
    };

    updateSlides();
    window.addEventListener("resize", updateSlides);

    return () => window.removeEventListener("resize", updateSlides);
  }, []);

  const outerSettings = {
    dots: false,
    arrows: slides > 1,
    infinite: true,
    speed: 500,
    slidesToShow: slides,
    slidesToScroll: 1,
  };

  const innerSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
  };

  const [countdowns, setCountdowns] = useState({});
  const navigate = useNavigate();

  const handleViewDetails = (id, propeId) => {
    // Open the route in a new tab with query params
    const url = `/propertyDetail?id=${id}&propeId=${propeId}`;
    window.open(url, "_blank");
  };

  const requestBody = {
    isApproved: true,
    page: 0,
    size: 30,
    sell: false,
    currentUser: userId,
    isResidential: true,
  };
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await fetch(`${baseUrl}/property/list`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        if (data.data.content) {
          const properties = data.data.content.filter(
            (item) => item.biddingDetails !== null,
          );

          setPropertyCards(properties);

          // favorites logic
          const favIds = properties
            .filter((item) => item.favorite === true)
            .map((item) => item.id);

          setFavorites(favIds);
        } else {
          console.error("API response invalid:", data);
        }
      } catch (error) {
        console.error("Error fetching properties:", error);
      } finally {
        setLoading(false); // stop loader once data loaded
      }
    };

    fetchProperties();
  }, []);

  // Optimized Countdown
  function Countdown({ start, end }) {
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
      const interval = setInterval(() => setNow(Date.now()), 1000);
      return () => clearInterval(interval);
    }, []);

    const timeLeft = useMemo(() => {
      if (!start || !end) return "";

      const startTime = new Date(start).getTime();
      const endTime = new Date(end).getTime();

      if (isNaN(startTime) || isNaN(endTime)) return "";

      if (now < startTime) {
        const diff = startTime - now;
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);
        return `Starts In: ${days}D : ${hours}H : ${minutes}M : ${seconds}S`;
      }

      if (now >= startTime && now < endTime) {
        const diff = endTime - now;
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);
        return `Ends In: ${days}D : ${hours}H : ${minutes}M : ${seconds}S`;
      }

      return "Offer Ended";
    }, [now, start, end]);

    return <h3>{timeLeft}</h3>;
  }

  // If still loading, show animation
  if (loading) {
    return (
      <div className="slider-loader">
        <div className="spinner"></div>
        <p>Loading properties...</p>
      </div>
    );
  }

  return (
    <section className="recommended-section" style={{ marginTop: "27px" }}>
      <div className="container-fluid px-3">
        <div className="text-center mb-5">
          <h2 className="fw-bold remd">
            Residential Exclusive Offers Available in Your Area
          </h2>
        </div>

        <SlickSlider {...outerSettings}>
          {propertyCards.map((card, index) => {
            const images =
              card.propertyImages && card.propertyImages.length > 0
                ? card.propertyImages
                : [{ imageUrl: bidingimg }];

            const address = `${card.streetAddress || ""}, ${card.city || ""}, ${
              card.state || ""
            } ${card.zipcode || ""}`;

            const price = card?.biddingDetails?.listPrice || card.propertyValue;

            return (
              <div key={index} className="px-2">
                <div className="property-card">
                  <div className="property-image position-relative">
                    <SlickSlider {...innerSettings}>
                      {images.map((img, i) => (
                        <div key={i}>
                          <img
                            src={img.imageUrl}
                            alt={`property-${card.id}-${i}`}
                            className="img-fluid rounded-top"
                            style={{
                              height: "250px",
                              objectFit: "cover",
                              width: "100%",
                            }}
                          />
                        </div>
                      ))}
                    </SlickSlider>

                    {/* {card.listingId == null && card.propeId != null && (
                      <div
                        className="position-absolute top-0 start-0 text-white px-2 py-1 small m-2 rounded"
                        style={{ background: "#144788" }}
                      >
                        Exclusive
                      </div>
                    )} */}
                    {card.propeId !== null &&
                      card.propeId !== undefined &&
                      card.propeId !== "" &&
                      card.propeId !== "null" && (
                        <div
                          className="position-absolute top-0 start-0 text-white px-2 py-1 small m-2 rounded"
                          style={{ background: "rgb(203 35 34)" }}
                        >
                          Exclusive
                        </div>
                      )}

                    <div
                      className="fav-icon position-absolute top-0 end-0 m-2"
                      onClick={() => toggleFavorite(card.id)}
                      style={{
                        cursor: "pointer",
                        borderRadius: "50%",
                        padding: "6px",
                      }}
                    >
                      <i
                        className={`fa${
                          favorites.includes(card.id) ? "s" : "r"
                        } fa-heart`}
                        style={{
                          color: favorites.includes(card.id) ? "red" : "#ccc",
                          fontSize: "27px",
                          transition: "color 0.2s ease",
                        }}
                      ></i>
                    </div>
                    <img src={Residin} className="vtrimg kilhome" alt="" />
                     {card.sell === true && (
                      <img src={Sold} alt="" srcset="" className="sold" />
                     )}
                  </div>
                  <div
                    className="auctions-info"
                    onClick={() => {
                      const listedBy =
                        card.user?.name || card.originatingSystemName;
                      const email = card.user?.email || "";
                      handleViewDetails(card.id, card.propeId);
                    }}
                  >
                    <div className="auctions-details">
                      {card.propertyType && (
                        <h1 className="listed-by">{card.propertyType}</h1>
                      )}

                      {(card.listingId || card.propeId) && (
                        <h3 className="mls">
                          {card.listingId ? (
                            <>
                              <strong>MLS No:</strong> {card.listingId}
                            </>
                          ) : (
                            <>
                              <strong>Property Id:</strong> {card.propeId}
                            </>
                          )}
                        </h3>
                      )}

                      {(card.user?.name || card.originatingSystemName) && (
                        <p className="listed-by">
                          Listed by{" "}
                          <span>
                            {card.user?.name || card.originatingSystemName}
                          </span>
                        </p>
                      )}

                      <h3 className="address">
                        {card.unparsedAddress || "No Address"}
                      </h3>
                      <div className="property-specs">
                        {card.bedroomsTotal > 0 && (
                          <span className="spec">
                            🛏{card.bedroomsTotal}bed
                          </span>
                        )}

                        {card.bathroomsTotalInteger > 0 && (
                          <span className="spec">
                            🛁{card.bathroomsTotalInteger}bath
                          </span>
                        )}

                        {card.lotSizeArea > 0 && (
                          <span className="spec">📐{card.lotSizeArea}ft</span>
                        )}
                      </div>
                      {!(
                        !card.biddingDetails ||
                        card.biddingDetails.isBidEnd === true
                      ) && (
                        <p className="listed-by kiojkio">
                          Listing Price{" "}
                          <span>${formatNumberCA(card.listPrice)}</span>
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="bgfix">
                    {card.sell !== true ? (
                      <div className="CURENTS">
                        <div className="price-section">
                          <p className="price-label">
                            <p className="price-label">
                              {card.biddingDetails == null
                                ? "Listing Price"
                                : card.isBidEnd === false
                                  ? "Listing Price"
                                  : "Current Offer Price"}
                            </p>
                          </p>

                          {/* <p className="price-label">Current Listing Price</p> */}
                        </div>

                        <h4 className="prices">
                          {(() => {
                            const details = card.biddingDetails;

                            // CASE 1: If biddingDetails exists
                            if (details) {
                              // If bid has ended → show listPrice
                              if (
                                details.isBidEnd !== null &&
                                details.isBidEnd === true
                              ) {
                                return `$${formatNumberCA(card.listPrice)}`;
                              }

                              // If bid NOT ended → show currentAuctionAmount OR offerStartingPrice
                              return `$${formatNumberCA(
                                details.currenntAuctionAmount ??
                                  details.offerStartingPrice,
                              )}`;
                            }

                            // CASE 2: If biddingDetails does NOT exist → show listPrice
                            return `$${formatNumberCA(card.listPrice)}`;
                          })()}
                        </h4>
                      </div>
                    ) : (
                      <div className="CURENTS">
                        <div className="price-section">
                          <p className="price-label">
                            <p className="price-label">Current Sold Price :</p>
                          </p>
                        </div>
                        <h4 className="prices"></h4>
                      </div>
                    )}
                    <div className="timebtn">
                      {card.sell !== true ? (
                        <Countdown
                          start={card.biddingDetails?.bidingStartDateTime}
                          end={card.biddingDetails?.bidingEndDateTime}
                        />
                      ) : (
                        <p className="soldbtn">
                          <b>Sold to :</b> 
                        </p>
                      )}
                      <button
                        className="view-btn"
                        onClick={() => {
                          const listedBy =
                            card.user?.name || card.originatingSystemName;
                          const email = card.user?.email || "";
                          handleViewDetails(card.id, card.propeId);
                        }}
                      >
                        View Details
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </SlickSlider>
        {/* <div class="expobtn">
          <Link to="/buyer">
            <button className="arowr">
              Explore All Properties <img src={arowr} alt="" />
            </button>
          </Link>
        </div> */}
      </div>
    </section>
  );
};

export default PropertySlider;
